import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Container, Header, Segment, List } from "semantic-ui-react";
import { useStore } from "../../../stores/store";

interface Props {
  onNavigateNext: () => void;
}

export default function PreSurveyHomePage({ onNavigateNext }: Props) {
  const { t } = useTranslation("common");
  const { commonStore } = useStore();

  const content_en = (
    <>
      <Segment inverted color="blue" className="survey-intro-header">
        <Header as="h1"> About RefleCT</Header>
      </Segment>
      <div className="pre-post-txt">
        <strong>RefleCT - (Reflection of e-Competencies of Teachers),</strong> is a self-assessment tool
        for teachers to reflect on their competence to use digital technologies for teaching and
        learning. It consists of 32 questions subdivided into 6 key areas of digital competence.
      </div>
      <List bulleted style={{ paddingLeft: "20px" }}>
        <List.Item>Professional Development</List.Item>
        <List.Item>Digital Resources</List.Item>
        <List.Item>Teaching and Learning</List.Item>
        <List.Item>Assessment</List.Item>
        <List.Item>Empowering Learners</List.Item>
        <List.Item>Facilitating Learners’ Digital Competence</List.Item>
      </List>
    </>
  );

  const content_kh = (
    <>
      <Segment inverted color="blue" className="survey-intro-header">
        <Header as="h1">
          អំពី <b>RefleCT</b>
        </Header>
      </Segment>
      <div className="pre-post-txt">
        <strong>RefleCT</strong> - (ការឆ្លុះបញ្ចាំងពីសមត្ថភាពឌីជីថលរបស់គ្រូបង្រៀន)
        គឺជាឧបករណ៍ឆ្លុះបញ្ចាំងសមត្ថភាពផ្ទាល់ខ្លួនរបស់លោកគ្រូ
        អ្នកគ្រូក្នុងការប្រើប្រាស់បច្ចេកវិទ្យាឌីជីថលសម្រាប់ការបង្រៀន និងរៀន។ ឧបករណ៍នេះមាន ៣២ សំណួរ
        និងបែងចែកជា ៦ ផ្នែកសំខាន់ៗ។
      </div>
      <List bulleted style={{ paddingLeft: "20px" }}>
        <List.Item>ការអភិវឌ្ឍន៍វិជ្ជាជីវៈ</List.Item>
        <List.Item>ធនធានឌីជីថល</List.Item>
        <List.Item>ការបង្រៀននិងរៀន</List.Item>
        <List.Item>ការវាយតម្លៃ</List.Item>
        <List.Item>ការផ្តល់សិទ្ធិអំណាចដល់សិស្ស</List.Item>
        <List.Item>ការសម្របសម្រួលដល់សមត្ថភាពឌីជីថលរបស់សិស្ស</List.Item>
      </List>
    </>
  );

  const content_vn = (
    <>
      <Segment inverted color="blue" className="survey-intro-header">
        <Header as="h1"> Về RefleCT</Header>
      </Segment>
      <div className="pre-post-txt">
        <strong>RefleCT - (Reflection of e-Competencies of Teachers - Đánh giá năng lực số của giáo viên),</strong> là một công cụ tự đánh giá nhằm giúp giáo viên xác định năng lực sử dụng công nghệ số trong dạy và học của mình. Nó bao gồm 32 câu hỏi được chia thành 6 lĩnh vực chính của năng lực kỹ thuật số.
      </div>
      <List bulleted style={{ paddingLeft: "20px" }}>
        <List.Item>Phát triển chuyên môn</List.Item>
        <List.Item>Tài nguyên kỹ thuật số</List.Item>
        <List.Item>Dạy và học</List.Item>
        <List.Item>Đánh giá</List.Item>
        <List.Item>Trao quyền cho người học</List.Item>
        <List.Item>Hỗ trợ người học phát triển năng lực kỹ thuật số</List.Item>
      </List>
    </>
  );

  const content_id = (
    <>
      <Segment inverted color="blue" className="survey-intro-header">
        <Header as="h1"> Tentang RefleCT</Header>
      </Segment>
      <div className="pre-post-txt">
        <strong>RefleCT - (Reflection of e-Competencies of Teachers),</strong> adalah alat asesmen diri guru untuk merefleksikan kemampuan mereka dalam menggunakan teknologi digital dalam pengajaran dan pembelajaran. Terdiri atas 32 pertanyaan yang terbagi dalam enam area kunci kompetensi digital.
      </div>
      <List bulleted style={{ paddingLeft: "20px" }}>
        <List.Item>Pengembangan Profesional</List.Item>
        <List.Item>Sumber Daya Digital</List.Item>
        <List.Item>Pengajaran dan Pembelajaran</List.Item>
        <List.Item>Penilaian</List.Item>
        <List.Item>Pemberdayaan Siswa</List.Item>
        <List.Item>Memfasilitasi Kompetensi Digital Siswa</List.Item>
      </List>
    </>
  );
  
  return (
    <>
      {commonStore.lang === "en" && content_en}
      {commonStore.lang === "kh" && content_kh}
      {commonStore.lang === "vn" && content_vn}
      {commonStore.lang === "id" && content_id}
      <Container className="survey-btns">
        <Segment>
          <Button
            primary
            floated="right"
            content={t("Common.Next")}
            onClick={() => {
              onNavigateNext();
            }}
          ></Button>
        </Segment>
      </Container>
    </>
  );
}
